// Modules
import React from "react";
import cn from "classnames";
interface SuggestionResultParts {
	text: string;
	highlight: boolean;
}

const SuggestionResults = ({ parts }: { parts: SuggestionResultParts[] }): JSX.Element => {
	return (
		<span className="wk-list-definition wk-icon-search">
			{parts.map((part, index) => (
				<span className={cn("", { highlight: part.highlight })} key={`${part.text}-${index}`} dangerouslySetInnerHTML={{ __html: part.text }} />
			))}
		</span>
	);
};

export default SuggestionResults;
